import { ReactComponent as MenuArrowIcon } from './menu_arrow.svg';

export default MenuArrowIcon;
